import { render, staticRenderFns } from "./Faceapi.vue?vue&type=template&id=0534fb69&scoped=true"
import script from "./Faceapi.vue?vue&type=script&lang=js"
export * from "./Faceapi.vue?vue&type=script&lang=js"
import style0 from "./Faceapi.vue?vue&type=style&index=0&id=0534fb69&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534fb69",
  null
  
)

export default component.exports